<template>

  <div id="vue-ticket-support">

   <div v-if="loadingScreen" style="position:absolute;background-color:#fff;top: 0;left: 0;right: 0;bottom: 0;z-index:9999;"></div>

   <div v-if="loadingWorkingScreen" class="container-loading">
      <div class="loading">
        <img src="/wp-content/themes/portinvoice/images/Spinner-1s-600px.gif" width="100%">
      </div>
   </div>

<!--    <div v-if="loadingScreen" class="container-loading">
            <p style="text-align: center;">
                {{ $t('global.laden') }} <v-ons-icon icon="fa-spinner" spin></v-ons-icon>
            </p>
        </div> -->

    <div class="wrapper_content">

      <div class="site-content">

        <!-- <h1 class="entry-title">Empfangsjournal</h1> -->

        <!-- <app-navigation>
           Load the App Navigation Component
        </app-navigation> -->
        
        <router-view>
          <!-- Load the router-view component provided by the vue-router plugin -->
        </router-view>

      </div>

    </div>

  </div><!-- #vue-search-app -->

</template>

<script>
import AppNavigation from './components/AppNavigation';

export default {

  data() {
    return {
      apiResponse: '', // initial loading or error messages.
      wpPosts: [], // REST API response data goes here.
      wpData, // global data made available via wp_localize_script.
      isDataAvailable: false
    };
  },

   beforeMount() {
      //this.isLoggedIn();
   },

   computed: {
      loadingScreen() {
         return this.$store.getters.getLoadingStartScreen
      },
      loadingWorkingScreen() {
         return this.$store.getters.getLoadingWorkingScreen
      }
   },

   methods: {

      isLoggedIn() {
         var user_id = 0
         var data = {
            'nonce': this.wpData.nonce,
            'restURL': this.wpData.rest_url
         }
         this.$store.dispatch('isPortinvoiceLoggedIn', data)
            .then(resp => {
               if (resp.data.user_id == 0) {
                  window.location.href = 'https://vali-e.com/konto/';
               } else {
                  this.$store.commit('setStopLoadingScreen')
               }
            })
            .catch(err => {
               window.location.href = 'https://vali-e.com/konto/';
            })      
      }
   },


	components: {
		'app-navigation': AppNavigation
	}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue